export function LogRegLogo() {
    function onClickLogo() {
        window.location.href = "/";
    }

    return (
        <h1 onClick={onClickLogo}>Edithor</h1>
    );
  }
  